<template>
  <div>
    <main>
      <section class="absolute w-full h-full">
        <div class="absolute top-0 w-full h-full "
          style="background: linear-gradient(135deg, #CCD7CC, #E896A3, #A9C0EB, #5D7EB2)">
        </div>
        <div class="container mx-auto px-4 h-full">
          <div class="flex content-center items-center justify-center h-full">
            <div class="w-full lg:w-8/12 px-4">
              <div
                class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                <div class="flex-auto p-8 ">
                  <h6 class="text-gray-600 text-2xl font-medium ">
                    Sign In To Your Account
                  </h6>
                  <form @submit.prevent class="mt-8">
                    <div class="relative w-full mb-3">
                      <label class="block  text-gray-700 text-s  mb-2" for="grid-password">
                        Phone number
                      </label>
                      <Input type="text" class="focus:outline-none w-full" v-model="user.phone"
                        placeholder="555-555-5555" style="transition: all 0.15s ease 0s;" inputmode="numeric"
                        pattern="[0-9]*" name="phone" @keypress.enter="login" />
                    </div>
                    <span class="text-xs font-extralight">
                      We will send you a verification code to your phone. We will never share your phone number or spam
                      you.
                    </span>
                    <div class="text-center mt-6">
                      <ul class="list text-red-500">
                        <li v-for="err in errors" :key="err">{{ err }}</li>
                      </ul>
                    </div>
                    <div class="text-center mt-6">
                      <Button class="text-white w-full" type="button" name="submit"
                        style="transition: all 0.15s ease 0s;" @click="login()">
                        Login
                      </Button>
                      <div class="text-gray-500 text-center mb-3 ">
                        <small>Don't have an account yet? <a href="/signup" class="underline">sign up</a></small>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { useAuthStore } from '@/stores/auth'
  import router from '@/router'
  import { Button } from '@/components/ui/button'
  import { Input } from '@/components/ui/input'
  import { isErrorModel, type ErrorModel, type ErrorDetail } from '@/models/error'

  const user = ref({ phone: '' })
  const errors = ref<string[]>([])
  const authStore = useAuthStore()

  const login = async () => {
    errors.value = []
    if (user.value.phone === '') {
      errors.value.push('Please enter a phone number')
      return
    }
    try {
      await authStore.login(user.value.phone)
      router.push('/verify?phone=' + user.value.phone)
    } catch (err: any) {
      if (isErrorModel(err.body)) {
        const e = err.body as ErrorModel
        if (e.title) errors.value.push(e.title)
        if (e.detail) errors.value.push(e.detail)
        e.errors?.forEach((errDetail: ErrorDetail) => {
          errors.value.push(errDetail.message)
        })
      } else if (err?.message) {
        errors.value.push(err.message)
      } else {
        errors.value.push('An error occurred')
      }
    }
  }
</script>
